import {
  type SearchPerformancePagesSortBy,
  type SearchPerformancePagesSourceType,
} from '../api/searchPerformanceApi';

export type PagesSortField = 'impressions' | 'clicks' | 'ctrPct' | 'lastCrawledAt';

export type PagesSort = {
  field: PagesSortField;
  order: 'asc' | 'desc';
};

/**
 * The source whose view owns each sortable column (visibility column
 * ownership, D050). A tab page is listed from the owner of the active sort;
 * the other source only decorates those rows.
 */
export const SORT_FIELD_SOURCE: Record<PagesSortField, SearchPerformancePagesSourceType> = {
  impressions: 'GSC',
  clicks: 'GSC',
  ctrPct: 'GSC',
  lastCrawledAt: 'PRERENDER',
};

export const SORT_FIELD_API_SORT_BY: Record<PagesSortField, SearchPerformancePagesSortBy> = {
  impressions: 'impressions',
  clicks: 'clicks',
  ctrPct: 'ctr',
  lastCrawledAt: 'last_crawled',
};

export function otherSource(sourceType: SearchPerformancePagesSourceType): SearchPerformancePagesSourceType {
  return sourceType === 'GSC' ? 'PRERENDER' : 'GSC';
}
